import { render, staticRenderFns } from "./KModal.vue?vue&type=template&id=25163438&"
import script from "./KModal.vue?vue&type=script&lang=js&"
export * from "./KModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports